export class MicroappFbsTarif{
    number_of_units: number;
    tarif_id: string;
    tarif_name: string;
    unit_price:number;
}